import { createFileRoute, Link } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { useTheme } from '@/components/providers/ThemeProvider';

import { SignUpForm } from './-components/SignUpForm';

export const Route = createFileRoute('/(auth)/sign-up/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { resolvedTheme } = useTheme();

  return (
    <section className="bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          <img
            className="mr-2"
            src={resolvedTheme === 'dark' ? '/LogoWhite.svg' : '/LogoBlack.svg'}
            alt="logo"
            width={100}
            height={100}
          />
        </div>
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              <FormattedMessage id="auth.signUp.title" />
            </h1>
            <SignUpForm />
            <p className="text-sm font-light text-gray-500 dark:text-gray-400">
              <FormattedMessage id="auth.signUp.alreadyHaveAccount" />
              <Link
                to="/sign-in"
                className="font-medium hover:underline text-primary-600 dark:text-primary-500"
              >
                <FormattedMessage id="auth.signUp.signIn" />
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
